'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { TanStackDevtools } from '@tanstack/react-devtools';
/**
 * TanStack Devtools component for development
 *
 * A framework-agnostic devtool for managing and debugging devtools.
 * Automatically shows in development mode only.
 * Can be explicitly enabled/disabled via the `enabled` prop.
 *
 * @example
 * ```tsx
 * // app/layout.tsx
 * import { TanStackDevtools } from '@sandstone/dev-tools/tanstack-devtools';
 *
 * export default function RootLayout({ children }) {
 *   return (
 *     <html>
 *       <body>
 *         {children}
 *         <TanStackDevtools />
 *       </body>
 *     </html>
 *   );
 * }
 * ```
 */
export function TanStackDevtoolsComponent({ enabled, ...props }) {
    const shouldShow = enabled ?? process.env.NODE_ENV === 'development';
    if (!shouldShow) {
        return null;
    }
    return _jsx(TanStackDevtools, { ...props });
}
